import React from "react";

import * as Icon from "react-feather";

export const SidebarData = [
  {
    label: "Strategy",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Strategy",
    submenuItems: [
      {
        label: "Products",
        link: "/products",
        icon: <Icon.Box />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Marketing",
        link: "/marketing",
        icon: <Icon.ShoppingCart />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Order List",
        link: "/order-list",
        icon: <Icon.Briefcase />,
        showSubRoute: false,
        submenu: false,
      },

      {
        label: "Media Plans",
        link: "/media-plans",
        icon: <Icon.Mail />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Costs",
        link: "/costs",
        icon: <Icon.DollarSign />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Estimated Cash Flow",
        link: "/estimated-cash-flow",
        icon: <Icon.TrendingUp />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Analytics",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Analytics",
    submenuItems: [
      {
        label: "Mailing Response",
        link: "/mailing-report",
        icon: <Icon.BarChart2 />,
        showSubRoute: false,
        submenu: false,
      },

      {
        label: "Sales Dashboard",
        link: "/sales-dashboard",
        icon: <Icon.BarChart />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Mail Files",
        link: "/mail-files",
        icon: <Icon.Mail />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Customers",
        link: "/customer",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Data",
        link: "/data",
        icon: <Icon.Database />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "Accounting",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Accounting",
    submenuItems: [
      {
        label: "Sales Dashboard",
        link: "/accounting/sales-dashboard",
        icon: <Icon.TrendingUp />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Reports",
        link: "/accounting/reports-list",
        icon: <Icon.BarChart2 />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Accounts Payable",
        link: "/accounting/accounts-payable",
        icon: <Icon.ArrowDown />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Accounts Receivable",
        link: "/accounting/accounts-receivable",
        icon: <Icon.ArrowUp />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Transactions & Allocations",
        link: "/accounting/transactions-allocations",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Advance Accounting",
        link: "/accounting/advance-accounting",
        icon: <Icon.RefreshCw />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Letter Processing Records",
        link: "/accounting/letter-processing-records",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Settings",
        link: "/accounting/settings",
        icon: <Icon.Settings />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Letter Processing",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Letter Processing",
    submenuItems: [
      {
        label: "Letter Processing",
        link: "/letter-processing",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Tools",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Tools",
    submenuItems: [
      {
        label: "PDF Parser",
        link: "/pdf-parser",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },

  {
    label: "Settings",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Clients",
    submenuItems: [
      {
        label: "Clients",
        link: "/Settings/clients",
        icon: <Icon.User />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Access Control",
        link: "/access-control",
        icon: <Icon.Lock />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
];
